import { GameType } from '../../Enums/GameType';
import { DGGameDailyData } from './DGGameDailyData';
import { DGGameThemeData } from './DGGameThemeData';

export class DGGame {
  public constructor(public id: string, public type: GameType, public data: DGGameDailyData | DGGameThemeData) {}
}
